import React from "react";

const BusService = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M8.7998 17H15.7998M8.7998 17C8.7998 18.1046 7.90437 19 6.7998 19C5.69524 19 4.7998 18.1046 4.7998 17M8.7998 17C8.7998 15.8954 7.90437 15 6.7998 15C5.69524 15 4.7998 15.8954 4.7998 17M15.7998 17C15.7998 18.1046 16.6952 19 17.7998 19C18.9044 19 19.7998 18.1046 19.7998 17M15.7998 17C15.7998 15.8954 16.6952 15 17.7998 15C18.9044 15 19.7998 15.8954 19.7998 17M19.7998 17H20.7998C21.9044 17 22.7998 16.1046 22.7998 15V12.8284C22.7998 12.298 22.5891 11.7893 22.214 11.4142L17.3856 6.58579C17.0105 6.21071 16.5018 6 15.9714 6H4.7998C3.69524 6 2.7998 6.89543 2.7998 8V15C2.7998 16.1046 3.69524 17 4.7998 17M14.7998 9L17.7998 12H12.7998V9H14.7998ZM9.7998 9H5.7998V12H9.7998V9Z"
        stroke="#00A3BC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BusService;
